<template>
  <div class="w-full mx-auto md:container px-2 grid gap-6 lg:grid-cols-3">
    <ul class="list-none relative lg:col-span-2 pt-5 pb-0 lg:pb-5 grid md:grid-cols-2 gap-6" role="menu">
      <nav-accessory-card
        v-for="(item, index) of mixedLayoutData[0]"
        ref="card"
        :key="index"
        :right-function="focusNextColumn"
        :left-function="
          (e) => {
            !isCompactView ? focusPreviousColumn(e) : focusParentTier();
          }
        "
        :down-function="focusNextElement"
        :up-function="focusPreviousElement"
        :label="item.linkName"
        :description="item.linkDescription"
        :image="item.linkAssetID"
        :qaid="item.uid"
        :url="composeLink(item.url)"
      />
    </ul>
    <ul class="list-none lg:pt-5 pb-2 mb-5 lg:col-span-1 lg:mb-0 w-full md:w-1/2 lg:w-fit" role="menu">
      <li v-for="(item, index) of mixedLayoutData[1]" :key="index" class="ml-2">
        <a
          ref="link"
          :href="composeLink(item.url)"
          :target="setTarget(item.target)"
          role="menuitem"
          :qaid="item.uid"
          class="nav__menu-item leading-[40px] flex items-center text-sm font-medium hover:underline"
          tabindex="-1"
          @keydown.prevent.right="focusNextColumn"
          @keydown.prevent.left="
            (e) => {
              !isCompactView ? focusPreviousColumn(e) : focusParentTier();
            }
          "
          @keydown.prevent.down="focusNextElement"
          @keydown.prevent.up="focusPreviousElement"
        >
          <span class="flex items-center gap-1 pointer-events-none relative">
            {{ item.linkName }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import NavAccessoryCard from '@/navigation/NavAccessoryCard.vue';
import {mapState} from 'vuex';
import links from '@/navigation/mixins/links.js';
export default {
  name: 'NavMixedLayout',
  components: {
    NavAccessoryCard,
  },
  mixins: [links],
  inject: ['focusParentTier', 'focusNextMenuItem', 'isElectra', 'focusPreviousMenuItem'],

  props: {
    navItemData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    links() {
      const links = [];
      this.$refs.card.forEach((child) => {
        links.push(child.$refs.link);
      });
      this.$refs.link.forEach((link) => {
        links.push(link);
      });

      return links;
    },
    mixedLayoutData() {
      const layoutData = [[], []];
      this.navItemData.links.forEach((navItem) => {
        if (navItem?.hasVisibleProducts !== false && navItem?.visible !== false) {
          if (navItem.linkAssetID) {
            layoutData[0].push(navItem);
          } else {
            layoutData[1].push(navItem);
          }
        }
      });
      return layoutData;
    },
  },

  methods: {
    focusPreviousColumn(e) {
      const newFocusedItem = e.target.parentNode.parentNode.previousElementSibling
        ? e.target.parentNode.parentNode.previousElementSibling?.querySelector('.nav__menu-item')
        : e.target.parentNode.parentNode.parentNode.lastElementChild.querySelector('.nav__menu-item');
      e.target.tabIndex = -1;
      newFocusedItem.focus();
    },
    focusNextColumn(e) {
      const newFocusedItem = e.target.parentNode.parentNode.nextElementSibling
        ? e.target.parentNode.parentNode.nextElementSibling?.querySelector('.nav__menu-item')
        : e.target.parentNode.parentNode.parentNode.firstElementChild.querySelector('.nav__menu-item');
      e.target.tabIndex = -1;
      newFocusedItem.focus();
    },

    focusNextElement(e) {
      const elIndex = this.links.indexOf(e.target);
      e.target.tabIndex = -1;
      const targetIndex = elIndex < this.links.length - 1 ? elIndex + 1 : 0;

      this.links[targetIndex].tabIndex = 0;
      this.links[targetIndex].focus();
    },
    focusPreviousElement(e) {
      const elIndex = this.links.indexOf(e.target);
      if (elIndex === 0 && !this.isCompactView) {
        this.focusParentTier(e);
        return;
      }
      e.target.tabIndex = -1;
      const targetIndex = elIndex > 0 ? elIndex - 1 : this.links.length - 1;
      this.links[targetIndex].tabIndex = 0;
      this.links[targetIndex].focus();
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-content {
  grid-auto-rows: 40px;

  @media (screen(lg)) {
    grid-template-rows: repeat(auto-fit, 40px);
    grid-auto-flow: column;
    grid-template-columns: calc(1080px / 3);
    max-height: calc(85vh - var(--nav-tier-1-height, 0px) - var(--header-height));
    min-height: calc(400px + 5rem);

    li {
      width: calc(1080px / 3);
    }
  }
}

.nav-marketing-card {
  width: calc(1080px / 3);
}
</style>
